import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 杂志分页列表
export const setMagazinePages: Mutation<IModuleState> = (state, payload) => {
  state.magazinePage.data = payload.data;
  state.magazinePage.total = payload.total;
  state.magazinePage.pageNum = payload.pageNum;
  state.magazinePage.pageSize = payload.pageSize;
  state.magazinePage.loading = !!payload.loading;
};

// 杂志详情
export const setMagazineDetail: Mutation<IModuleState> = (state, payload) => {
  state.magazineDetail.data = payload.data;
  state.magazineDetail.loading = !!payload.loading;
};

// 平台的专案组分页列表
export const setPlatformDpgPages: Mutation<IModuleState> = (state, payload) => {
  state.dpgPage.data = payload.data;
  state.dpgPage.total = payload.total;
  state.dpgPage.pageNum = payload.pageNum;
  state.dpgPage.pageSize = payload.pageSize;
  state.dpgPage.loading = !!payload.loading;
};

// 专案组详情
export const setDpgDetail: Mutation<IModuleState> = (state, payload) => {
  state.dpgDetail.data = payload.data;
  state.dpgDetail.loading = !!payload.loading;
};

// 待授权的组织列表
export const setAllAuthOrgs: Mutation<IModuleState> = (state, payload) => {
  state.allAuthOrgs.data = payload.data;
  state.allAuthOrgs.total = payload.total;
  state.allAuthOrgs.pageNum = payload.pageNum;
  state.allAuthOrgs.pageSize = payload.pageSize;
  state.allAuthOrgs.loading = !!payload.loading;
};

// 已授权的组织列表
export const setAuthedOrgs: Mutation<IModuleState> = (state, payload) => {
  state.authedOrgs.data = payload.data;
  state.authedOrgs.total = payload.total;
  state.authedOrgs.pageNum = payload.pageNum;
  state.authedOrgs.pageSize = payload.pageSize;
  state.authedOrgs.loading = !!payload.loading;
};

// 已保存的过滤项配置
export const setSavedFilters: Mutation<IModuleState> = (state, payload) => {
  state.savedFilters.data = payload.data;
  state.savedFilters.loading = !!payload.loading;
};

// 待添加的物品列表(左库)
export const setAllModels: Mutation<IModuleState> = (state, payload) => {
  state.allModels.data = payload.data;
  state.allModels.total = payload.total;
  state.allModels.pageNum = payload.pageNum;
  state.allModels.pageSize = payload.pageSize;
  state.allModels.loading = !!payload.loading;
};

// 待添加的材料列表(左库)
export const setAllMaterials: Mutation<IModuleState> = (state, payload) => {
  state.allMaterials.data = payload.data;
  state.allMaterials.total = payload.total;
  state.allMaterials.pageNum = payload.pageNum;
  state.allMaterials.pageSize = payload.pageSize;
  state.allMaterials.loading = !!payload.loading;
};

// 杂志的物品列表(右库)
export const setLibModels: Mutation<IModuleState> = (state, payload) => {
  state.libModels.data = payload.data;
  state.libModels.loading = !!payload.loading;
};

// 杂志的材料列表(右库)
export const setLibMaterials: Mutation<IModuleState> = (state, payload) => {
  state.libMaterails.data = payload.data;
  state.libMaterails.loading = !!payload.loading;
};

// 物料库调整日志(右库)
export const setLibLogs: Mutation<IModuleState> = (state, payload) => {
  state.libLogs.data = payload.data;
  state.libLogs.total = payload.total;
  state.libLogs.pageNum = payload.pageNum;
  state.libLogs.pageSize = payload.pageSize;
  state.libLogs.loading = !!payload.loading;
};

// 杂志状态字典
export const setStatusTypes: Mutation<IModuleState> = (state, payload) => {
  state.statusTypes.data = payload.data;
  state.statusTypes.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.data = payload.data;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
